import { VerticalArrowDropzoneIcon } from '@ui/kit/icons';
import { tokens, emptyDropzone, placeholder } from './atom.empty.style.js';
import { jsx } from 'react/jsx-runtime';

function EmptyDropzone(props) {
  return /*#__PURE__*/jsx("div", {
    ref: props.setNodeRef,
    className: emptyDropzone,
    "data-over": props.isOver,
    "data-transparent": !props.settings.visibleDropzones,
    style: tokens.__override({
      top: `${props.dropzone.placement.y * 100}%`,
      left: `${props.dropzone.placement.x * 100}%`,
      width: `${props.dropzone.placement.width * props.scale}px`,
      height: `${props.dropzone.placement.height * props.scale}px`,
      maskSrc: props.dropzone.meta.maskSrc ? `url(${props.dropzone.meta.maskSrc})` : undefined
    }),
    children: props.settings.visibleDropzones && /*#__PURE__*/jsx("div", {
      className: placeholder,
      children: /*#__PURE__*/jsx(VerticalArrowDropzoneIcon, {})
    })
  });
}

export { EmptyDropzone };
//# sourceMappingURL=atom.empty.js.map
